import { SortingTypes } from '@decisiv/ui-components/lib/components/Table';

/**
 * Creates a sort function for a given field and callback. This helper is commonly used
 * on table column definitions to handle sorting.
 * @param fieldName - The name of the field to sort by.
 * @param callback - The callback function to execute on sort.
 * @returns A function that takes a sort direction and calls the callback with the field name and direction.
 */
export const sortFactory =
  (
    fieldName: string,
    callback: (fieldName: string, direction: SortingTypes) => void,
  ) =>
  (direction: SortingTypes) =>
    callback(fieldName, direction);
